import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Facebook(props) {
  const { isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect fill="#1877F2" height="24" rx={isRound ? '100%' : 0} width="24" />
      <path
        d="M15.9898 7.875H17.5029V4.92188C17.5029 4.92188 16.1297 4.6875 14.8168 4.6875C12.0757 4.6875 10.2842 6.34875 10.2842 9.35625V12H7.2373V15.4688H10.2842V24H14.0342V15.4688H16.8303L17.3623 12H14.0342V9.74906C14.0342 8.80008 14.4992 7.875 15.9898 7.875Z"
        fill="white"
      />
    </svg>
  );
}

Facebook.propTypes = propTypes;
Facebook.defaultProps = defaultProps;

export default Facebook;
